  (function () {
    // Config travels on this script tag, so one cached file serves every
    // caller (4 instances on the homepage) instead of 4 inline copies.
    var me = document.currentScript;
    if (!me || !me.dataset.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + me.dataset.sectionId);
    if (!sectionEl) return;
    var IMGS = 'img[data-defer-src]';
    // 0 until the section is approached, 1 once the per-card observers are
    // armed, 2 once the failsafe has run (from then on, hydrate on sight).
    var stage = 0;

    function hydrate(img) {
      if (!img || img.__deferHydrated) return;
      img.__deferHydrated = true;
      var ss = img.getAttribute('data-defer-srcset');
      if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-defer-srcset'); }
      var s = img.getAttribute('data-defer-src');
      if (s) { img.setAttribute('src', s); img.removeAttribute('data-defer-src'); }
    }
    function hydrateAll() {
      sectionEl.querySelectorAll(IMGS).forEach(hydrate);
    }
    function failsafe() {
      stage = 2;
      hydrateAll();
    }

    // Cards can land after every pass below has already run.
    // product-recommendations fetches its cards and injects them with
    // innerHTML (so the copy of this script in that response never executes),
    // then re-fetches on every sibling swatch switch. Each pass only sees the
    // imgs present when it fires, so those cards kept data-defer-src for good:
    // blank tiles. Late arrivals join whichever stage is current; before the
    // approach there is nothing to do, since armScrollers reads the live DOM.
    function addsDeferred(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.matches(IMGS) || node.querySelector(IMGS))) return true;
        }
      }
      return false;
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        if (!stage || !addsDeferred(mutations)) return;
        if (stage === 2) hydrateAll(); else armScrollers();
      }).observe(sectionEl, { childList: true, subtree: true });
    }

    if (!('IntersectionObserver' in window)) { failsafe(); return; }

    function armScrollers() {
      var scrollers = sectionEl.querySelectorAll(me.dataset.scrollerSelector);
      if (!scrollers.length) { hydrateAll(); return; }
      scrollers.forEach(function (scroller) {
        // One observer per scroller, reused when late cards re-arm it.
        var io = scroller.__deferIO || (scroller.__deferIO = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { hydrate(e.target); obs.unobserve(e.target); }
          });
        }, { root: scroller, rootMargin: '200px 600px' }));
        scroller.querySelectorAll(IMGS).forEach(function (img) { io.observe(img); });
      });
      // Anything outside a matched scroller still hydrates on approach.
      sectionEl.querySelectorAll(IMGS).forEach(function (img) {
        var inScroller = false;
        scrollers.forEach(function (s) { if (s.contains(img)) inScroller = true; });
        if (!inScroller) hydrate(img);
      });
    }

    function start() {
      var approach = new IntersectionObserver(function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            obs.disconnect();
            if (!stage) stage = 1;
            armScrollers();
            return;
          }
        }
      }, { rootMargin: '400px 0px' });
      approach.observe(sectionEl);
    }

    var gate = (window.DFYNE && window.DFYNE.heroReady && window.DFYNE.heroReady.then)
      ? window.DFYNE.heroReady : Promise.resolve();
    gate.then(start, start);

    // Failsafe: after load + idle, everything left hydrates regardless —
    // guarantees the strip is fully populated long before it could matter,
    // without ever touching the LCP window. A copy that executes after load
    // would never see the event, so it schedules straight away.
    function scheduleFailsafe() {
      var schedule = window.requestIdleCallback
        ? function (cb) { window.requestIdleCallback(cb, { timeout: 10000 }); }
        : function (cb) { setTimeout(cb, 4000); };
      schedule(failsafe);
    }
    if (document.readyState === 'complete') scheduleFailsafe();
    else window.addEventListener('load', scheduleFailsafe);
  })();
